import {
  FETCH_MENUS_PENDING,
  FETCH_MENUS_SUCCESS,
  FETCH_MENUS_ERROR,
  FETCH_MENU_DETAILS_PENDING,
  FETCH_MENU_DETAILS_SUCCESS,
  FETCH_MENU_DETAILS_ERROR,
  FETCH_PRODUCT_DETAILS_PENDING,
  FETCH_PRODUCT_DETAILS_SUCCESS,
  FETCH_PRODUCT_DETAILS_ERROR,
  UPDATE_PRODUCT_PENDING,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_ERROR,
  UPDATE_DIRECTORY_PENDING,
  UPDATE_DIRECTORY_SUCCESS,
  UPDATE_DIRECTORY_ERROR,
  UPDATE_MENU_PENDING,
  UPDATE_MENU_SUCCESS,
  UPDATE_MENU_ERROR,
  LOAD_COMMON_DATA_PENDING,
  LOAD_COMMON_DATA_SUCCESS,
  LOAD_COMMON_DATA_ERROR,
  CLEAR_MENU_DETAILS,
  CLEAR_DIRECTORY_VIEW,
  CLEAR_PRODUCT,
  CLEAR_ALL_MENU_DATA,
  ADD_MENU_TO_STORE,
  UPDATE_MENU_IN_STORE,
  DELETE_MENU_FROM_STORE,
  FETCH_ALL_MENU_DETAILS_SUCCESS,
  UPDATE_DIRECTORY_IN_STORE,
  UPDATE_CATEGORY_IN_STORE,
  SET_PRODUCTS_VERSION,
} from "../actions/menu";

export const MenuInitialState: any = {
  // Menu List
  menus: [],
  categoriesInfo: {},
  categories: [],

  // Menu Details
  menuDetails: {},

  // Directory Views
  directoryViews: {},

  // Products
  products: {},

  // Common data
  tags: {},
  departments: [],
  groups: [],
  productConfig: null,

  // Loading states
  isLoading: false,
  error: null,
  loadingActions: {},
};

interface Action {
  type: string;
  payload: any;
  error?: any;
}

export const MenuReducer = (state = MenuInitialState, action: Action) => {
  switch (action.type) {
      // Add this case for SET_PRODUCTS_VERSION
    case SET_PRODUCTS_VERSION:
      return {
        ...state,
        productsVersion: action.payload,
      };

    // Fetch All Menu Details Success
    case FETCH_ALL_MENU_DETAILS_SUCCESS:
      return {
        ...state,
        menuDetails: action.payload,
        isLoading: false,
        error: null,
      };

    // Update Directory in Store
    case UPDATE_DIRECTORY_IN_STORE:
      const updatedDirectory = action.payload;
      const updatedMenuDetails = { ...state.menuDetails };

      const findAndUpdateInNode = (
        node: any,
        targetId: number,
        updatedData: any,
      ): boolean => {
        if (!node) return false;
        if (node.id === targetId) {
          node.valid = updatedData.valid;
          node.version = updatedData.version;
          node.name = updatedData.name;
          node.colour = updatedData.colour;
          node.img = updatedData.img;
          node.desc = updatedData.desc;
          return true;
        }
        if (node.wrapper) {
          for (const key in node.wrapper) {
            if (findAndUpdateInNode(node.wrapper[key], targetId, updatedData)) {
              return true;
            }
          }
        }
        return false;
      };

      Object.keys(updatedMenuDetails).forEach((menuId) => {
        const menuData = updatedMenuDetails[menuId];
        if (menuData?.menuNodeList && menuData.menuNodeList[menuId]?.category) {
          for (const catKey in menuData.menuNodeList[menuId].category) {
            const category = menuData.menuNodeList[menuId].category[catKey];
            if (category.wrapper) {
              for (const wrapperKey in category.wrapper) {
                if (
                  findAndUpdateInNode(
                    category.wrapper[wrapperKey],
                    updatedDirectory.id,
                    updatedDirectory,
                  )
                ) {
                  break;
                }
              }
            }
          }
        }
      });

      return {
        ...state,
        menuDetails: updatedMenuDetails,
      };

    // Fetch Menus
    case FETCH_MENUS_PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case UPDATE_CATEGORY_IN_STORE:
      const updatedCategory = action.payload;
      const updatedMenuDetailsCat = { ...state.menuDetails };

      // Find and update category in all menu details
      Object.keys(updatedMenuDetailsCat).forEach((menuId) => {
        const menuData = updatedMenuDetailsCat[menuId];
        if (menuData?.categoryNode) {
          const categoryIndex = menuData.categoryNode.findIndex(
            (cat: any) => cat.id === updatedCategory.id,
          );
          if (categoryIndex !== -1) {
            menuData.categoryNode[categoryIndex] = {
              ...menuData.categoryNode[categoryIndex],
              ...updatedCategory,
            };
          }
        }

        // Also update in menuNodeList if present
        if (menuData?.menuNodeList && menuData.menuNodeList[menuId]?.category) {
          const categoryInNode =
            menuData.menuNodeList[menuId].category[updatedCategory.id];
          if (categoryInNode) {
            menuData.menuNodeList[menuId].category[updatedCategory.id] = {
              ...categoryInNode,
              ...updatedCategory,
            };
          }
        }
      });

      return {
        ...state,
        menuDetails: updatedMenuDetailsCat,
      };
    case FETCH_MENUS_SUCCESS:
      return {
        ...state,
        menus: action.payload.menus,
        categoriesInfo: action.payload.categoriesInfo,
        categories: action.payload.categories,
        isLoading: false,
        error: null,
      };
    case FETCH_MENUS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };

    // Fetch Menu Details
    case FETCH_MENU_DETAILS_PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_MENU_DETAILS_SUCCESS:
      return {
        ...state,
        menuDetails: {
          ...state.menuDetails,
          [action.payload.menuId]: action.payload.data,
        },
        isLoading: false,
        error: null,
      };
    case FETCH_MENU_DETAILS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };

    // Fetch Product Details
    case FETCH_PRODUCT_DETAILS_PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_PRODUCT_DETAILS_SUCCESS:
      if (action.payload) {
        return {
          ...state,
          products: {
            ...state.products,
            [action.payload.productId]: action.payload.data,
          },
          isLoading: false,
          error: null,
        };
      }
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    case FETCH_PRODUCT_DETAILS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };

    // Update Product
    case UPDATE_PRODUCT_PENDING:
      return {
        ...state,
        loadingActions: {
          ...state.loadingActions,
          updateProduct: true,
        },
      };
    case UPDATE_PRODUCT_SUCCESS:
      const { productId, updatedProduct } = action.payload;
      return {
        ...state,
        products: {
          ...state.products,
          [productId]: state.products[productId]
            ? {
                ...state.products[productId],
                productData: updatedProduct,
                selectedProduct: [updatedProduct],
                wrapperData: {
                  ...state.products[productId].wrapperData,
                  ...updatedProduct.itemWrapperId,
                },
              }
            : state.products[productId],
        },
        loadingActions: {
          ...state.loadingActions,
          updateProduct: false,
        },
      };
    case UPDATE_PRODUCT_ERROR:
      return {
        ...state,
        loadingActions: {
          ...state.loadingActions,
          updateProduct: false,
        },
        error: action.error,
      };

    // Update Directory
    case UPDATE_DIRECTORY_PENDING:
      return {
        ...state,
        loadingActions: {
          ...state.loadingActions,
          updateDirectory: true,
        },
      };
    case UPDATE_DIRECTORY_SUCCESS:
      return {
        ...state,
        loadingActions: {
          ...state.loadingActions,
          updateDirectory: false,
        },
      };
    case UPDATE_DIRECTORY_ERROR:
      return {
        ...state,
        loadingActions: {
          ...state.loadingActions,
          updateDirectory: false,
        },
        error: action.error,
      };

    // Update Menu
    case UPDATE_MENU_PENDING:
      return {
        ...state,
        loadingActions: {
          ...state.loadingActions,
          updateMenu: true,
        },
      };
    case UPDATE_MENU_SUCCESS:
      const updatedMenu = action.payload.updatedMenu;
      console.log("sdfasfafagasdfasd", {
        ...state,
        menus: state.menus.map((menu: any) =>
          menu.id === updatedMenu.id ? { ...updatedMenu } : menu,
        ),
        loadingActions: {
          ...state.loadingActions,
          updateMenu: false,
        },
      });
      return {
        ...state,
        menus: state.menus.map((menu: any) =>
          menu.id === updatedMenu.id ? { ...updatedMenu } : menu,
        ),
        loadingActions: {
          ...state.loadingActions,
          updateMenu: false,
        },
      };
    case UPDATE_MENU_ERROR:
      return {
        ...state,
        loadingActions: {
          ...state.loadingActions,
          updateMenu: false,
        },
        error: action.error,
      };

    // Load Common Data
    case LOAD_COMMON_DATA_PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case LOAD_COMMON_DATA_SUCCESS:
      return {
        ...state,
        tags: action.payload.tags,
        departments: action.payload.departments,
        groups: action.payload.groups,
        productConfig: action.payload.productConfig,
        isLoading: false,
        error: null,
      };
    case LOAD_COMMON_DATA_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };

    // Add Menu to Store (No API call - for real-time update after create)
    case ADD_MENU_TO_STORE:
      return {
        ...state,
        menus: [...state.menus, action.payload],
        isLoading: false,
        error: null,
      };

    // Update Menu in Store (No API call - for real-time update after edit/deactivate)
    case UPDATE_MENU_IN_STORE:
      return {
        ...state,
        menus: state.menus.map((menu: any) =>
          menu.id === action.payload.id ? { ...menu, ...action.payload } : menu,
        ),
        isLoading: false,
        error: null,
      };

    // Delete Menu from Store (No API call - for real-time update after delete)
    case DELETE_MENU_FROM_STORE:
      return {
        ...state,
        menus: state.menus.filter((menu: any) => menu.id !== action.payload),
        isLoading: false,
        error: null,
      };

    // Clear Actions
    case CLEAR_MENU_DETAILS:
      const newMenuDetails = { ...state.menuDetails };
      delete newMenuDetails[action.payload];
      return {
        ...state,
        menuDetails: newMenuDetails,
      };

    case CLEAR_DIRECTORY_VIEW:
      const newDirectoryViews = { ...state.directoryViews };
      delete newDirectoryViews[action.payload];
      return {
        ...state,
        directoryViews: newDirectoryViews,
      };

    case CLEAR_PRODUCT:
      const newProducts = { ...state.products };
      delete newProducts[action.payload];
      return {
        ...state,
        products: newProducts,
      };

    case CLEAR_ALL_MENU_DATA:
      return {
        ...state,
        menuDetails: {},
        directoryViews: {},
        products: {},
      };

    default:
      return state;
  }
};
